import styled from 'styled-components';
import { MapWrapper as Parent } from '../Base/style';

export const MapWrapper = styled(Parent)`
.gm-style-iw #content a {
    padding: 0;
    font-size: 13px;
  }
`;
